module.exports = __webpack_public_path__ + "static/media/detect-location-restaurant.1fb76961.svg";